<template>
  <div :class="rootClass">
    <p :class="`${rootClass}__title`">{{ title }}</p>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      rootClass: 'vehicle-card-section'
    }
  }
}
</script>

<style lang="scss">
.vehicle-card-section {
  $root-class: &;

  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #f0f0f0;

  &:first-of-type {
    border-top: none;
    padding-top: 0;
  }

  &__title {
    font-size: 0.75rem;
    line-height: 1.2;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #666;
    margin-bottom: 1rem;
  }
}
</style>
